export enum LoanPropertyHadPermitAtClosingType {
    Yes,
    No,
    NAPermitNotRequired,
}
